<app-breadcrumb *ngIf="!disableBreadcrumb" [master]="'Newsletter'" [parentName]="currentNewsletterObject?.newsletterName ? currentNewsletterObject?.newsletterName : 'Newlsetter'" [name]="'Aktualne'"></app-breadcrumb>
<ngx-extended-pdf-viewer
  *ngIf="currentNewsletterObject"
  [src]="'/rest/crm/newsletter/' + currentNewsletterObject.uuid  + '/pdf'"
  [zoom]="zoom"
  [backgroundColor]="'#fafafa'"
  [showPresentationModeButton]="true"
  [showPrintButton]="false"
  [showTextEditor]="false"
  [showDownloadButton]="false"
  [showRotateButton]="false"
  [showSecondaryToolbarButton]="false"
  [showDrawEditor]="false"
  [showOpenFileButton]="false"

></ngx-extended-pdf-viewer>
<!--<ngx-extended-pdf-viewer-->
<!--  *ngIf="currentNewsletterObject"-->
<!--  [src]="'/rest/crm/newsletter/' + currentNewsletterObject.uuid  + '/pdf'"-->
<!--  [showToolbar]="true"-->
<!--  [showSidebarButton]="true"-->
<!--  [showFindButton]="true"-->
<!--  [showPagingButtons]="true"-->
<!--  [showDrawEditor]="false"-->
<!--  [showTextEditor]="false"-->
<!--  [showZoomButtons]="true"-->
<!--  [showPresentationModeButton]="true"-->
<!--  [showOpenFileButton]="false"-->
<!--  [showPrintButton]="false"-->
<!--  [showDownloadButton]="false"-->
<!--  [showSecondaryToolbarButton]="false"-->
<!--  [showRotateButton]="false"-->
<!--  [showHandToolButton]="false"-->
<!--  [showScrollingButton]="false"-->
<!--  [showSpreadButton]="false"-->
<!--  [showPropertiesButton]="false"-->
<!--  [pageViewMode]="'book'"-->
<!--  [zoom]="zoom"-->
<!--  [backgroundColor]="'#fafafa'"-->

<!--&gt;</ngx-extended-pdf-viewer>-->
